import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class UserService {

    getEventRoute = '/api/user/';

    constructor(private dataService: DataService) {
    };

    salesdetail(result: boolean) {
        return this.dataService.post('/api/user/SaveSalesRep', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    resellerdetail(result: boolean) {
        return this.dataService.post('/api/user/addOrUpdateResellerDetail', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    deletesaledetail(id) {
        return this.dataService.delete('/api/user/DeleteSalesRep/' + id);
    }

    deletereselldetail(id) {
        return this.dataService.delete('/api/user/DeleteResell/' + id);
    }

    GetSalesDetail(refresh) {
        return this.dataService.getData('/api/user/GetSalesRep', refresh);

    }
    applyFilter(search) {
        return this.dataService.getRecord('/api/user/getsalesrepbysearch/' + search);
    }
    applyreselFilter(search) {
        return this.dataService.getRecord('/api/user/getresellbysearch/' + search);
    }

    GetResellGetAll(refresh) {
        return this.dataService.getData('/api/user/GetResell', refresh);
    }

    GetById(id, refresh) {
        return this.dataService.getData('/api/user/GetSalesRep/' + id, refresh);
    }

    GetResellId(id, refresh) {
        return this.dataService.getData('/api/user/GetResell/' + id, refresh);
    }

    getTitleType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/titleType', refresh);
    }
    getRoleType(refresh) {
        return this.dataService.getData('/api/lookup/userroletype', refresh);
    }
    getGenderType(refresh) {
        return this.dataService.getData('/api/lookup/gendertype', refresh);
    }

    getCancellationType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/cancellationType', refresh);
    }


    getApplicationList(refresh) {
        return this.dataService.getData('/api/lookup/getApplicationList', refresh);
    }
    getApplicationServiceChangeList(refresh) {
        return this.dataService.getData('/api/lookup/getApplicationServiceChangeList', refresh);

    }

    save(result: any) {
        return this.dataService.post('/api/user', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getPaymentUrl(urlkey: any, refresh) {
        return this.dataService.getData('/api/user/getPaymentUrl/' + urlkey, refresh);

    }

    updateUser(result: any) {
        return this.dataService.post('/api/user/updateUser', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    updateuserBenefits(result: any) {
        return this.dataService.post('/api/user/updateuserBenefits', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    forgotpasswordUser(user: any) {
        return this.dataService.post('/api/user/forgotpassword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    changepasswordUser(user: any) {
        return this.dataService.post('/api/user/changePassword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    addToHistory(refNo) {
        return this.dataService.getRecord('/api/user/AdminAddToHistory/' + refNo);
    }
    getUser(userId, refresh) {
        return this.dataService.getData('/api/user/' + userId, refresh);
    }
    getVendorImg(refresh) {
        return this.dataService.getData('/api/product/voucher', refresh);
        return this.dataService.getData('/api/product/voucher', refresh);
    }

    getsalesdetail(refresh) {
        return this.dataService.getData('/api/user/SaveSalesRep', refresh)
    }


    getRecurringApplicationList(refresh) {
        return this.dataService.getData('/api/lookup/recurringapplication', refresh);
    }

    postPayoutBatch(result: any) {
        return this.dataService.post('/api/user/postpayoutsbatch', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getAmendCustomer(emailSearch) {
        return this.dataService.getRecord('/api/user/getAmendCustomer/' + emailSearch);
    }

    submitAmendCustomer(result: any) {
        return this.dataService.post('/api/user/submitAmendCustomer', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    resetPassword(result: any) {
        return this.dataService.post('/api/user/resetPassword', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getVerifiedUsers() {
        return this.dataService.getRecord('/api/user/getVerifiedUserList');
    }

    getRedeemReport() {
        return this.dataService.getRecord('/api/user/getRedeemCoupenDetails');
    }

    changePin(data: any) {
        return this.dataService.post('/api/user/changePin', data);
    }

    getFriendReferralDetailsById(friendDetailsId: number) {
        return this.dataService.getRecord('/api/friendDetails/getFriendReferralDetailsById/' + friendDetailsId);
    }

    getQContactTicketList() {
        return this.dataService.getRecord('/api/support/getQContactTicketList')
    }

    getSupportHistoryList(supportId) {
        return this.dataService.getRecord('/api/support/getSupportHistoryList/' + supportId)
    }
    //    getAllTickets(searchQuery?: string) {
    //   const url = searchQuery
    //     ? `/api/support/getAllQContactTicketList?searchQuery=${encodeURIComponent(searchQuery)}`
    //     : `/api/support/getAllQContactTicketList`;

    //   return this.dataService.getRecord(url);
    // }

    getServiceProviderType() {
        return this.dataService.getData('/api/lookup/getServiceProviderType', true);
    }

    GetApplicationStatusType() {
        return this.dataService.getData('/api/lookup/getApplicationStatusType', true);
    }

    getAllTickets(searchQuery?: string, fromDate?: Date, toDate?: Date,) {

        let url = '/api/support/getAllQContactTicketList';
        const params: string[] = [];

        if (searchQuery) {
            params.push(`searchQuery=${encodeURIComponent(searchQuery)}`);
        }

        if (fromDate) {
            params.push(`fromDate=${encodeURIComponent(fromDate.toISOString())}`);
        }

        if (toDate) {
            params.push(`toDate=${encodeURIComponent(toDate.toISOString())}`);
        }

        if (status) {
            params.push(`status=${encodeURIComponent(status)}`);
        }

        if (params.length > 0) {
            url += '?' + params.join('&');
        }

        return this.dataService.getRecord(url);
    }

    // saveUser(data: any) {
    //    return this.dataService.post('/api/user/CreateOrUpdateUser', data)

    // }
    saveUser(result: any) {
        return this.dataService.post('/api/user/CreateOrUpdateUser', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getUserById(userId: number) {
        return this.dataService.getData(`/api/user/${userId}`, true);
    }
    // getResellerCode(userId: number) {
    //     return this.dataService.getData(`/api/user/${userId}`, true);
    // }
}





